import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
})

function AuthLayout() {
  // Auth pages render full-screen — no Navbar or Footer
  return <Outlet />
}
